module.exports = __webpack_public_path__ + "img/00048.d8a28681.webp";